import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import { useScrollReset } from './lib/useScrollReset';
import { Footer } from './layout/Footer';
import { MobileTabs } from './layout/MobileTabs';
import { Nav } from './layout/Nav';
import { AskPage } from './pages/AskPage';
import { FeaturePage } from './pages/FeaturePage';
import { CoachPage } from './pages/CoachPage';
import { ComparePage } from './pages/ComparePage';
import { CostliestPage } from './pages/CostliestPage';
import { GamePage } from './pages/GamePage';
import { HomePage } from './pages/HomePage';
import { LeaguePage } from './pages/LeaguePage';
import { NotFoundPage } from './pages/NotFoundPage';
import { TrendsPage } from './pages/TrendsPage';

function Shell({ children }: { children: React.ReactNode }) {
  useScrollReset();
  return <>{children}</>;
}

/** A fresh boundary per route, so a failure on one page does not stick to the next. */
function RouteErrorBoundary({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  return <ErrorBoundary key={pathname}>{children}</ErrorBoundary>;
}

export default function App() {
  return (
    <BrowserRouter>
      <Shell>
      <Nav />
      <main className="min-h-screen pb-24 md:pb-0">
        {/* keyed by path so navigating away from a broken page clears the error */}
        <RouteErrorBoundary>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/nfl" element={<LeaguePage league="nfl" />} />
          <Route path="/college" element={<LeaguePage league="cfb" />} />
          <Route path="/analysis" element={<AskPage />} />
          <Route path="/ask" element={<AskPage />} />
          <Route path="/trends" element={<TrendsPage />} />
          <Route path="/grades" element={<TrendsPage />} />
          <Route path="/given-away" element={<CostliestPage />} />
          <Route path="/compare" element={<ComparePage />} />
          <Route path="/predict" element={<FeaturePage feature="predict" />} />
          <Route path="/betting" element={<FeaturePage feature="betting" />} />
          <Route path="/breakdown" element={<FeaturePage feature="breakdown" />} />
          <Route path="/coach/:name" element={<CoachPage />} />
          <Route path="/game/:id" element={<GamePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        </RouteErrorBoundary>
      </main>
      <Footer />
      <MobileTabs />
      </Shell>
    </BrowserRouter>
  );
}
